
import ProductDetails from './product-details.vue'
import SizeFit from './size-fit.vue'
import MaterialCare from './material-care.vue'
export default {
  components: {
    ProductDetails,
    SizeFit,
    MaterialCare,
  },
  inject: ['wordingPageProduct'],
  props: {
    productSelected: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    openProductDetails: false,
    openSizeFit: false,
    openMaterialCare: false,
  }),
  methods: {
    tabHasContent(tab) {
      let hasContent = false
      const sizeDetails = Object.values(this.productSelected.sizes_details)
      switch (tab) {
        case 'product-details':
          hasContent =
            this.productSelected.description &&
            this.productSelected.description !== ''
          break
        case 'size-fit':
          hasContent =
            sizeDetails.filter((d) => d).length > 0 ||
            this.productSelected.fitting_guide
          break
        case 'material-care':
          hasContent = this.productSelected.materials.care_instructions
            ? this.productSelected.materials.care_instructions.length > 0
            : false
          break
        default:
          hasContent = false
          break
      }
      return hasContent
    },
    haveSizeFitInfo() {
      return !!(
        this.productSelected.sizes_details.top_cut ||
        this.productSelected.sizes_details.bottom_cut ||
        this.productSelected.sizes_details.fit_intention ||
        this.productSelected.sizes_details.fit_details ||
        this.productSelected.sizes_details.waist_type ||
        this.productSelected.sizes_details.leg_shape ||
        this.productSelected.sizes_details.thickness ||
        this.productSelected.sizes_details.back_length ||
        this.productSelected.sizes_details.inside_leg_measurement ||
        this.productSelected.sizes_details.length_information ||
        this.productSelected.sizes_details.model_size_data ||
        this.productSelected.sizes_details.dimensions.default ||
        this.productSelected.sizes_details.dimensions.height ||
        this.productSelected.sizes_details.dimensions.width ||
        this.productSelected.sizes_details.dimensions.depth ||
        this.productSelected.sizes_details.dimensions.top_handle_drop_length ||
        this.productSelected.sizes_details.dimensions
          .adjustable_shoulder_strap_drop_length ||
        this.productSelected.sizes_details.dimensions.strap_length
      )
    },
  },
}
